export const formatTime = (
  minutes: number
): { value: string; unit: string } => {
  const totalSeconds = Math.round(minutes * 60);

  if (totalSeconds === 0) {
    return { value: '0', unit: 's' };
  }

  if (totalSeconds < 60) {
    return { value: totalSeconds.toString(), unit: 's' };
  }

  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;

  if (s === 0) {
    return { value: m.toString(), unit: 'min' };
  }

  return { value: `${m}min ${s}s`, unit: '' };
};
